import { addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { ICross } from './Cross.type';

export const StyledCross = styled.div<ICross>`
	position: relative;

	display: flex;

	justify-content: center;
	align-items: center;

	width: 20px;
	height: 20px;

	cursor: pointer;

	${addTransition()}

	@media (hover: hover) {
		&:hover {
			opacity: 0.5;
		}
	}
	& > span {
		position: absolute;

		width: 100%;
		height: 3px;

		background-color: ${(p) => p.theme.colors.white};

		&:nth-child(1) {
			transform: rotate(45deg);
		}
		&:nth-child(2) {
			transform: rotate(-45deg);
		}
	}

	${(p) =>
		p.withBlurBackground
			? css`
					background: ${p.theme.colors.black};
					border: 1px solid ${p.theme.colors.gold};
					border-radius: 5px;
					padding: 5px;

					width: 25px;
					height: 25px;

					& > span {
						width: 80%;
					}
			  `
			: ''}
`;
